export default "__VITE_ASSET__77963c76__"